export const VALIDATE_DELETE_PASSENGERS = 'VALIDATE_DELETE_PASSENGERS'

export default (passengerIds: string[], flightId: string) => ({
  type: VALIDATE_DELETE_PASSENGERS,
  passengerIds,
  flightId,
})
